import React, { Component } from 'react';
import { Form, Field, FieldArray, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { get } from 'lodash';
import Link from 'components/atoms/buttons/standard/Link';
import PropTypes from 'prop-types';
import StyledLabel from 'components/atoms/inputs/Label';
import SelectList from 'components/atoms/inputs/SelectList';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import { AddNewButton, RemoveButton, FieldWrapper } from 'components/atoms/buttons/ListOperations';
import InputTip from 'components/atoms/form/InputTip';
import FormHeading from 'components/atoms/form/FormHeading';
import FormSubHeading from 'components/atoms/form/FormSubHeading';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import DimensionRowFormContainer from 'containers/forms/dynamicProfiles/DimensionRowFormContainer';
import DimensionPivotSelectContainer from 'containers/forms/dynamicProfiles/DimensionPivotSelectContainer';
import ToggleSwitch from 'components/atoms/form/ToggleSwitch';
import { colors } from 'services/theme/brandTheme/brandColors';
import { dv360DimensionCount, innovidDimensionCount } from 'constants/platforms';
import { INNOVID_DYNAMIC_PROFILE } from 'constants/capabilities';

const renderProfileIds = ({ fields, meta: { error, submitFailed } }) => {
    if (fields.length === 0) {
        fields.push();
    }

    return (
        <div>
            {fields.map((profileId, index) => (
                <Row style={{ display: 'flex' }} key={index}>
                    {submitFailed && error && <span>{error}</span>}
                    <Col xs={9} md={3}>

                        <FieldWrapper>
                            <Field component={TextInputAdmin} required={false} autocomplete="nope" type="text" name={profileId} />
                            {fields.length > 1 &&
                                <RemoveButton className='icon-close' type="button" title="Remove Profile ID" onClick={() => fields.remove(index)} />
                            }
                        </FieldWrapper>
                    </Col>
                </Row>
            ))}
            <AddNewButton type="button" title="Add Profile ID" style={{ marginBottom: '10px' }}
                onClick={() => fields.push('')}> {'Add Profile ID'}
            </AddNewButton>
        </div>
    );
};

const selector = formValueSelector('editDynamicProfile');

class EditDynamicProfile extends Component {
    constructor() {
        super();
        this.state = {
            brands: null,
            selectedBrandId: null,
            sortedBrands: [],
            profileType: 'dv360'
        };
    }

    static getDerivedStateFromProps(props, state) {
        const hasBrandsChanged = props.brands !== state.brands;
        const updatedState = { ...state, isActive: get(props, 'dynamicProfile.isActive', true) };


        if (hasBrandsChanged) {
            updatedState.brands = props.brands;
            updatedState.sortedBrands = props.brands.sort(EditDynamicProfile.nameSort);
        }

        return updatedState;
    }

    static nameSort = (a, b) => `${a.name}`.localeCompare(b.name)

    renderHeading() {
        if (this.props.dynamicProfile) {
            return (
                <FormHeading>Edit Dynamic Profile:&nbsp;
                    {this.props.dynamicProfile &&
                        <span>
                            {this.props.dynamicProfile.name}
                        </span>
                    }
                </FormHeading>
            );
        }

        return (
            <FormHeading>Create New Dynamic Profile</FormHeading>
        );
    }

    renderProfileIdText() {
        const profileIdText = 'Add multiple Profile IDs if the reporting dimensions are identical. This is the ID of the dynamic profile in Studio. This is a 7-8 digit number.';
        const campaignIdText = 'Add multiple Profile IDs if the reporting dimensions are identical. This is the ID of the campaign in Innovid. This is a 6 digit number.';

        return <InputTip>{this.props.profileType === 'innovid' ? campaignIdText : profileIdText}</InputTip>;
    }

    renderDimensions() {
        const dimensions = [];
        const dimensionCount = this.props.profileType === 'innovid' ? innovidDimensionCount : dv360DimensionCount;
        for (let i = 1; i <= dimensionCount; i += 1) {
            dimensions.push(<DimensionRowFormContainer key={i} index={i} profileType={this.props.profileType} />);
        }
        return dimensions;
    }

    toggleClick = () => {
        const isActive = !this.state.isActive;
        this.props.dispatch(change('editDynamicProfile', 'isActive', isActive));
    }

    toggleProfileType = () => {
        const profileIsdv360 = !this.state.profileIsdv360;
        this.state.profileIsdv360 = profileIsdv360;
        this.props.dispatch(change('editDynamicProfile', 'profileIsdv360', profileIsdv360));
    }

    render() {
        const profileTypes = this.props.currentUserScope.includes(INNOVID_DYNAMIC_PROFILE)
            ? [{ name: 'dv360', value: 'DV360' }, { name: 'innovid', value: 'Innovid' }]
            : [{ name: 'dv360', value: 'DV360' }];

        return (
            <Form onSubmit={this.props.handleSubmit()} id="editDynamicProfileForm">
                <Grid fluid>
                    {this.renderHeading()}
                    <Row>
                        <Col md={9}>
                            <Row>
                                <Col xs={9}>
                                    <StyledLabel>Name</StyledLabel><br />
                                    <Field component={TextInputAdmin} name="name" type="text" />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={9}>
                                    <StyledLabel>Profile Type</StyledLabel><br />
                                    <Field component={SelectList} list={profileTypes}
                                        name='profileType' >
                                    </Field>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={9}>
                                    <FormSubHeading>Profile IDs</FormSubHeading>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    {this.renderProfileIdText()}
                                </Col>
                            </Row>
                            <FieldArray name="profileIds" component={renderProfileIds} />
                            <Row>
                                <Col xs={9}>
                                    <StyledLabel>Brand</StyledLabel><br />
                                    <Field component={SelectList} list={this.state.sortedBrands}
                                        name='brandId' >
                                    </Field>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={3} >
                                    <FormSubHeading>Dimensions</FormSubHeading>
                                </Col>
                                <Col xs={3}>
                                    <FormSubHeading>Label</FormSubHeading>
                                </Col>
                                <Col xs={3}>
                                    <FormSubHeading>Show On Report</FormSubHeading>
                                </Col>
                            </Row>
                            {this.renderDimensions()}
                            <Row>
                                <Col xs={9} md={3}>
                                    <StyledLabel>Primary Pivot</StyledLabel><br />
                                    <Field component={DimensionPivotSelectContainer}
                                        name='pivotPrimary' >
                                    </Field>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={9} md={3}>
                                    <StyledLabel>Secondary Pivot</StyledLabel><br />
                                    <Field component={DimensionPivotSelectContainer}
                                        name='pivotSecondary' >
                                    </Field>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={9}>
                                    <StyledLabel>Active</StyledLabel><br />
                                    <Field component={ToggleSwitch} onChange={this.toggleClick} name="isActive" color={colors.goodwayBlue[400].hex} />
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '20px' }}>
                                <Col xs={9} >
                                    <ButtonStandardPrimary disabled={this.props.pristine} type="submit">Submit</ButtonStandardPrimary>
                                    <Link onClick={this.props.cancel}>Cancel</Link>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>

                        </Col>
                    </Row>
                </Grid>
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    profileType: selector(state, 'profileType')
});

EditDynamicProfile.propTypes = {
    dynamicProfile: PropTypes.object,
    handleSubmit: PropTypes.func,
    currentUserScope: PropTypes.array.isRequired,
    cancel: PropTypes.func.isRequired,
    brands: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(EditDynamicProfile);



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditDynamicProfile.js